import React, { useEffect, useState } from "react";
import "./Inovices.css";
import { IoPrintSharp } from "react-icons/io5";
import { FiSquare, FiXSquare } from "react-icons/fi";
import { LuCheckSquare } from "react-icons/lu";
import { IoMdClose } from "react-icons/io";
import Massage from "../../design/Massage";
import FetchMassage from "../../../faetures/FetchMassage";
import dateFormat from "../../../functions/dateFormat";
import { generateReceipt, getWorkerName, PostHttpGenerate } from '../../../faetures/fetch'

function AppInvoices({ data, user, userDetails }) {
  const [massage, setMassage] = useState({ open: false, num: 0 });
  const [massageFetch, setMassageFetch] = useState({ open: false, text: "" });
  const [currencyModal, setCurrencyModal] = useState({ open: false, receiptData: null });
  const [isAdmin, setIsAdmin] = useState(false)

  useEffect(() => {
    const admin = sessionStorage.getItem('admin') === 'admin';
    setIsAdmin(admin);
  }, [])



  const typeList = ["מזומן", "אשראי", "העברה", "צ'ק", "שובר"];

  const deleteInvAfterAgree = () => {
    setMassage((d) => ({ open: false, num: d.num }));
    setMassageFetch({ open: true, text: "" });
  };

  const massageFunResolve = (resolve) => {
    if (resolve[0] === 0) {
      setMassageFetch({ open: true, text: "שגיאה", url: "" });
    } else if (resolve[0] === 2) {
      setMassageFetch({ open: true, text: "קבלה עודכנה בהצלחה", url: "" });
    } else if (resolve[0] === 4) {
      setMassageFetch({ open: true, text: "אין אפשרות למחיקה", url: "" });
    }
  };


  const openCurrencyModal = (receiptData) => {
    setCurrencyModal({ open: true, receiptData });
  };

  const handleCurrencySelection = (currency) => {
    const receiptData = currencyModal.receiptData;
    const amount = currency === 'shekels' ? receiptData[7] : receiptData[8];
    const type = currency === 'shekels' ? 'ש"ח' : "דולר";
    printReceipt(receiptData, amount, type);
    setCurrencyModal({ open: false, receiptData: null });
  };



  function printReceipt(receiptData, amount, type) {
    console.log(receiptData);
    const data = {
      receipt_number: receiptData[0].toString().padStart(7, "0"),
      receipt_type: "original",
      first_name: userDetails.fnh ? userDetails.fnh : userDetails.firstName,
      last_name: userDetails.lnh ? userDetails.lnh : userDetails.lastName,
      id_number: userDetails.id,
      payment_type: typeList[receiptData[5]],
      amount: amount.toString(),
      type: type
    };

    generateReceipt('generate-receipt', data)
      .then(blob => {
        if (blob.type === 'application/pdf') {
          const url = URL.createObjectURL(blob);
          const newWindow = window.open();
          newWindow.document.write('<html><head><title>קבלה</title></head><body>');
          newWindow.document.write('<iframe src="' + url + '" frameborder="0" style="width:100%; height:100%;"></iframe>');
          newWindow.document.write('</body></html>');
          newWindow.document.close();
        } else {
          console.error('Expected PDF but received:', blob.type);
        }
      })
      .catch(error => {
        console.error('There was a problem with the fetch operation:', error);
      });
  }


  return (
    <>
      <div className="docketAccountHead">
        <p>העבר תשלום</p>
      </div>

      <div className="docketAccountData">
        <table>
          <thead>
            <tr>
              {[
                "מס'",
                "תאריך",
                "סכום ₪",
                "סכום $",
                "שם",
                "סוג תשלום",
                "סטטוס",
                "הדפסה",
                "ביטול",
                "מס' קבלה"
              ].map((value, key) => (
                <th key={key}> {value} </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {data &&
              Object.values(data).map((value, key) => (
                <tr key={key}>
                  <td> {key + 1} </td>
                  <td> {dateFormat(value[4])} </td>
                  <td style={{ fontWeight: "bold" }}>
                    {value[7]}
                    <span>₪</span>
                  </td>
                  <td style={{ fontWeight: "bold" }}> {value[8]}$ </td>
                  <td> {value[3]} </td>
                  <td> {typeList[value[5]]} </td>
                  <td>
                    {value[10] === 0 ? (
                      <FiSquare />
                    ) : Number(value[10]) === 1 ? (
                      <LuCheckSquare />
                    ) : (
                      <FiXSquare />
                    )}
                  </td>
                  <td>
                    <button onClick={() => openCurrencyModal(value)}>
                      <IoPrintSharp />
                    </button>
                  </td>
                  {isAdmin && <td onClick={() => setMassage({ open: true, num: value[0] })}>
                    <IoMdClose color="red" />
                  </td>}
                  <td> {value[0].toString().padStart(7, "0")}</td>
                </tr>
              ))}
          </tbody>
        </table>

        {massage.open && (
          <Massage
            text={`האם אתה בטוח שברצונך למחוק. קבלה מס' ${massage["num"]
              .toString()
              .padStart(7, "0")}`}
            setClose={() => setMassage(false)}
            buttonAgree={deleteInvAfterAgree}
          />
        )}

        {massageFetch.open && (
          <FetchMassage
            url={`invoices/delete?num=${massage.num}`}
            text={massageFetch.text}
            setMassage={setMassageFetch}
            fun={massageFunResolve}
            setClose={() => setMassageFetch({ open: false })}
          />
        )}

        {currencyModal.open && (
          <div className="currency-modal">
            <div className="modal-content">
              <h3>בחר מטבע להדפסה</h3>
              <button onClick={() => handleCurrencySelection('shekels')}>שקלים</button>
              <button onClick={() => handleCurrencySelection('dollars')}>דולרים</button>
              <button onClick={() => setCurrencyModal({ open: false, receiptData: null })}>ביטול</button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default AppInvoices;
